import { render } from "./AdminUserProfileTagManagement.vue?vue&type=template&id=2de86036&scoped=true"
import script from "./AdminUserProfileTagManagement.vue?vue&type=script&lang=js"
export * from "./AdminUserProfileTagManagement.vue?vue&type=script&lang=js"

import "./AdminUserProfileTagManagement.vue?vue&type=style&index=0&id=2de86036&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de86036"]])

export default __exports__